import React from "react";
import { Tooltip } from "antd";
import type { TCommunicationTask } from "../helpers/communication-types-helper";

interface ICommunicationOverviewFieldProps {
  task: TCommunicationTask;
}

const CommunicationOverviewField: React.FC<ICommunicationOverviewFieldProps> = ({ task }) => {
  const contextGroups = task.context_groups?.length
    ? task.context_groups
    : [{
      id: `context-${task.id}-0`,
      event_name: task.event_name || "\u2014",
      company_name: task.company_name || "\u2014",
      stand_number: task.stand_number || "",
    }];
  const visibleContextGroups = contextGroups.slice(0, 2);
  const hiddenGroupsCount = Math.max(0, contextGroups.length - visibleContextGroups.length);

  return (
    <div className="communication-overview-field">
      {visibleContextGroups.map((group) => {
        const eventLabel = group.event_name || "\u2014";
        const companyLabel = group.company_name || "\u2014";

        return (
          <div key={group.id} className="communication-overview-field__group">
            <Tooltip title={eventLabel}>
              <span className="communication-overview-field__tooltip-target">
                <strong className="communication-overview-field__event">{eventLabel}</strong>
              </span>
            </Tooltip>
            <Tooltip title={companyLabel}>
              <span className="communication-overview-field__tooltip-target">
                <span className="communication-overview-field__company">{companyLabel}</span>
              </span>
            </Tooltip>
          </div>
        );
      })}
      {hiddenGroupsCount > 0 && (
        <span className="communication-overview-field__more">{`+${hiddenGroupsCount} more`}</span>
      )}
    </div>
  );
};

export default CommunicationOverviewField;
